import storageManager from '@/api/storageManager';

const INVALID_TRACKING_VALUES = new Set(['undefined', 'null']);

const isValidTrackingValue = (value) =>
	typeof value === 'string' &&
	value.length > 0 &&
	!INVALID_TRACKING_VALUES.has(value);

const UTM_QUERY_PARAMS = [
	'utm_source',
	'utm_term',
	'utm_campaign',
	'utm_medium',
	'utm_content',
];

export const setupUtms = (searchParams) => {
	const params =
		searchParams instanceof URLSearchParams
			? searchParams
			: new URLSearchParams(searchParams || '');

	const utmData = {};
	UTM_QUERY_PARAMS.forEach((key) => {
		const value = params.get(key);
		if (isValidTrackingValue(value)) {
			utmData[key] = value;
		}
	});

	if (Object.keys(utmData).length > 0) {
		storageManager.utm.set(utmData);
	}

	const bp = params.get('bp');
	if (isValidTrackingValue(bp)) {
		storageManager.utm.setBrowsingPersonId(bp);
	}

	const sk = params.get('sk');
	if (isValidTrackingValue(sk)) {
		storageManager.utm.set({ sk });
	}

	let trackingId = params.get('uid');
	if (!isValidTrackingValue(trackingId)) {
		trackingId = storageManager.utm.get().uid;
	}

	const uid =
		(isValidTrackingValue(trackingId) && trackingId) ||
		`${Date.now().toString(16)}${Math.floor(Math.random() * 100)}`;

	storageManager.utm.set({ uid });

	return { uid };
};
